export const GET_CAMPAIGN_TAGS = 'GET_CAMPAIGN_TAGS'
export const GET_CAMPAIGN_TAGS_FULFILLED = 'GET_CAMPAIGN_TAGS_FULFILLED'
export const GET_CAMPAIGN_TAGS_REJECTED = 'GET_CAMPAIGN_TAGS_REJECTED'

/**
 * @param {{
 *  resourceType: string,
 *  resourceId: string,
 * }} payload
 * @link http://api.promoboxx.com/docs/V2/campaigns/tags.html
 */
export const getCampaignTags = (payload) => ({
  type: GET_CAMPAIGN_TAGS,
  payload,
})

export const GET_CAMPAIGNS = 'GET_CAMPAIGNS'
export const GET_CAMPAIGNS_FULFILLED = 'GET_CAMPAIGNS_FULFILLED'
export const GET_CAMPAIGNS_REJECTED = 'GET_CAMPAIGNS_REJECTED'

/**
 * @typedef Params
 * @property {number} [perPage] - number of results per page
 * @property {number} [offset] - starting offset
 * @property {string} [sortColumn] - column to sort on
 * @property {string} [sortDirection] - asc or desc
 * @property {object} [filters] - (facebook, twitter, instagram, embed, email, asset)
 * @property {array} [tags] - an array of tags dynamically created from campaigns
 * @property {array} [fields] - additional fields to include
 *
 * @param {{
 *  resourceType: string,
 *  resourceId: string,
 *  params: Params,
 * }} payload
 * @link https://promoboxx.postman.co/collections/5683350-e2c61ecf-b84d-4336-b8b0-94d1bd6e53c9?version=latest&workspace=d5e9e9bc-a697-4e1d-8dbc-56461f7af430#4ad3760f-9abc-4b14-a1c9-15c77de8cf0a
 */
export const getCampaigns = (payload) => ({
  type: GET_CAMPAIGNS,
  payload,
})

export const GET_CAMPAIGN = 'GET_CAMPAIGN'
export const GET_CAMPAIGN_FULFILLED = 'GET_CAMPAIGN_FULFILLED'
export const GET_CAMPAIGN_REJECTED = 'GET_CAMPAIGN_REJECTED'

/**
 * @typedef Params
 * @property {array} [fields] - additional fields to include
 *
 * @param {{
 *  campaignId: string,
 *  params: Params,
 * }} payload
 * @link https://promoboxx.postman.co/collections/5683350-e2c61ecf-b84d-4336-b8b0-94d1bd6e53c9?version=latest&workspace=d5e9e9bc-a697-4e1d-8dbc-56461f7af430#e0f1fcb3-8704-43ac-b8bd-de854db74236
 */
export const getCampaign = (payload) => ({
  type: GET_CAMPAIGN,
  payload,
})

export const DELETE_CAMPAIGN = 'DELETE_CAMPAIGN'
export const DELETE_CAMPAIGN_FULFILLED = 'DELETE_CAMPAIGN_FULFILLED'
export const DELETE_CAMPAIGN_REJECTED = 'DELETE_CAMPAIGN_REJECTED'

/** *
 * @param {{
 *  campaignId: string,
 * }} payload
 * @link http://api.promoboxx.com/docs/V2/campaigns/destroy.html
 */
export const deleteCampaign = (payload) => ({
  type: DELETE_CAMPAIGN,
  payload,
})

export const RESET_CAMPAIGN = 'RESET_CAMPAIGN'
export const RESET_CAMPAIGN_FULFILLED = 'RESET_CAMPAIGN_FULFILLED'
export const RESET_CAMPAIGN_REJECTED = 'RESET_CAMPAIGN_REJECTED'

/**
 * @param {{
 *  campaignId: string,
 * }} payload
 * @link http://api.promoboxx.com/docs/V2/campaigns/reset.html
 */
export const resetCampaign = (payload) => ({
  type: RESET_CAMPAIGN,
  payload,
})

export const CREATE_CAMPAIGN_COMMUNICATION = 'CREATE_CAMPAIGN_COMMUNICATION'
export const CREATE_CAMPAIGN_COMMUNICATION_FULFILLED =
  'CREATE_CAMPAIGN_COMMUNICATION_FULFILLED'
export const CREATE_CAMPAIGN_COMMUNICATION_REJECTED =
  'CREATE_CAMPAIGN_COMMUNICATION_REJECTED'

/**
 * @param {{
 *  brandId: string,
 *  campaignId: string,
 *  communicationType: string,
 * }} payload
 * @link http://api.promoboxx.com/docs/V2/communications/create.html
 */
export const createCampaignCommunication = (payload) => ({
  type: CREATE_CAMPAIGN_COMMUNICATION,
  payload,
})
